import React, { useContext, useState } from 'react'
import { webFetch } from 'shared/api'
import SearchOptionsContext from 'shared/components/context/search-options'
import Grid from 'shared/components/grid'
import { TVConfig } from 'shared/components/tv-util'
import { SearchOptionsPageData } from 'shared/types/page-data'
import Header from '../containers/header'
import { ExploreHeader } from './header/header'

type Props = {
    search: SearchOptionsPageData
    showTV: boolean
    isExplore?: boolean
}
const Search = ({ search, showTV, isExplore }: Props) => {
    const { user: searchUser, term } = search
    const { type, sort, setSearchResponseId, searchResponseId } = useContext(SearchOptionsContext)
    const isUserSearch = searchUser && searchUser.username
    const [totalCount, setTotalCount] = useState<number>()
    const fetchGifs = async (offset: number) => {
        const result = await webFetch.search(term, {
            offset,
            type,
            sort,
            explore: isExplore,
        })
        setTotalCount(result.pagination.total_count)
        if (!searchResponseId) setSearchResponseId(result.meta.response_id)
        return result
    }
    const tvConfig: TVConfig | undefined =
        !isUserSearch && showTV && !isExplore
            ? {
                  align: 'right',
                  channels: [`#${term.replace(/-/g, ' ')}`],
              }
            : undefined
    return (
        <>
            {isExplore ? (
                <ExploreHeader searchInfo={search} isSticker={search.isSticker} />
            ) : (
                <Header searchInfo={search} totalCount={totalCount} />
            )}
            <Grid key={`${type} ${sort}`} columns={4} tvConfig={tvConfig} fetchGifs={fetchGifs} />
        </>
    )
}

export default Search
